import React from "react";
import { observer } from "mobx-react-lite";
import { Layout } from "../../layout";
import { Routes, Route } from "react-router-dom";
import { PolicyList } from "./list";
import { PolicyCreate } from "./create/create";
import { PolicyDetailRoute } from "./detailRoute";
import { ConsoleContext } from "../../mobxStores/consoleContext/consoleContext";

const PolicyRoute: React.FC = () => {
  const { org } = ConsoleContext;

  return (
    <Layout key={org}>
      <Routes>
        <Route index element={<PolicyList />} />
        <Route path={`-create/*`} element={<PolicyCreate />} />
        <Route path={`:policy/*`} element={<PolicyDetailRoute />} />
      </Routes>
    </Layout>
  );
};

export default observer(PolicyRoute);
